var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmLeafsLeftSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 46,
    viewBox: "0 0 44 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-5.27746 3.4644L-1.59507 6.41339L-2.51133 1.69478C-0.612747 0.770939 1.79779 0.142681 4.67207 0.156231L7.43003 3.91815L7.44916 0.338108C9.57682 0.593921 11.981 1.15901 14.5969 2.14559C14.5969 2.14559 10.8754 5.83255 5.67506 8.66563L2.03221 4.99133L3.11122 9.95352C-1.09995 11.8614 -5.9376 12.8839 -10.3572 11.0804C-10.3572 11.0804 -9.21059 6.72987 -5.27746 3.4644Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1459 12.0441L27.2364 18.1089L23.2584 19.5024L14.628 11.3652L16.526 21.788L14.2581 22.5921L9.67966 18.3045L10.6399 23.8243L-0.520552 27.6462C-0.520552 27.6462 -2.40426 14.2121 11.125 8.57088C24.6178 2.875 34.6736 8.48016 39.4413 13.9843L31.1969 16.806L26.1459 12.0441Z",
    fill: "#2A7DFF",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmLeafsLeftSmall);
export default __webpack_public_path__ + "static/media/palmLeafsLeftSmall.42891ba0b2b47eae7c0a3aadab79c107.svg";
export { ForwardRef as ReactComponent };